export function* mapIterable<I, O>(input: Iterable<I>, fn: (x: I) => O): Iterable<O> {
  for (const x of input) {
    yield fn(x);
  }
}
